<template>

    <div class="fixed inset-0 h-screen bg-black/40 flex justify-center items-center  z-40 ">
        <div class="bg-white  rounded-xl shadow flex flex-col justify-center items-center space-y-3 max-w-[90%] ">

            <div v-if="props.component == 'registration'" class="w-full">

                <div class="w-full px-5 py-3 bg-slate-50 border-b border-gray-200 flex justify-center items-center rounded-t-xl text-emerald-500"
                    v-if="props.success">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-16">
                        <path fill-rule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                            clip-rule="evenodd" />
                    </svg>


                </div>

                <div class="w-full p-5 bg-slate-50 border-b border-gray-200 flex justify-center items-center rounded-t-xl text-red-500"
                    v-else>



                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16">
                        <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                        <path d="m15 11-6 6" />
                        <path d="m9 11 6 6" />
                    </svg>

                </div>
            </div>
            <div class="w-full" v-if="props.component == 'phone'">
                <div class="w-full px-5 py-3 bg-white border-b border-gray-200 flex justify-center items-center rounded-t-xl text-emerald-500"
                    v-if="props.success">
                    <transition name="fade" mode="out-in">
                        <unlocked_icon class="w-1/3" />
                    </transition>
                </div>

                <div class="w-full p-5 bg-white border-b border-gray-200 flex justify-center items-center rounded-t-xl text-red-500"
                    v-else>
                    <transition name="fade" mode="out-in">
                        <phone_verification_failed class="w-1/6" />
                    </transition>


                </div>
            </div>
            <div v-if="props.component == 'photos'" class="w-full">

                <div
                    class="w-full p-3 bg-slate-50 border-b border-gray-200 flex justify-center items-center rounded-t-xl text-gifty-pink">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16">
                        <path d="m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16" />
                        <path d="M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" />
                        <circle cx="13" cy="7" r="1" fill="currentColor" />
                        <rect x="8" y="2" width="14" height="14" rx="2" />
                    </svg>
                </div>
            </div>

            <div class=" text-center font-medium px-5 py-1  text-slate-600"
            :class="locale == 'ar' ? ' font-arabic ' : ' '">
                {{ $t("register." + props.message) }}</div>
        </div>
    </div>

</template>

<script setup>
import { defineProps } from 'vue';
import unlocked_icon from './icons/unlocked_icon.vue';
import Phone_verification_failed from './icons/phone_verification_failed.vue';
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()

const props = defineProps({
    success: {
        type: Boolean,
        required: true
    },
    message: {
        type: String,
        required: true
    },
    component: {
        type: String,
        required: true
    }
})

</script>